import React, { useState, useEffect } from "react";
import { Card } from "flowbite-react";
import clsx from "clsx";
import { NextArrow } from "../../common/icons";
import BackButton from "../UI/back-button";
import StepsIndicator from "../steps-indicator";
import Stripe from "./payment-methods/Stripe";
import AsiaPayClient from "./payment-methods/AsiaPayClient";
import AsiaPayDirectLink from "./payment-methods/AsiaPayDirectLink";
import LimePay from "./payment-methods/LimePay";
import PayWithPoints from "./payment-methods/PayWithPoints";
import AllLoginNotification from "../../components/UI/all-login-notif-card";

export default function PaymentMethod({
  isDirectLink,
  pwpUserData,
  goPreviousStep,
  currentStep,
  paymentName,
  pmName,
  isRenewalPage,
  pwpEnabled,
  languages,
  isPwpPointsEnabled,
  pwpData,
  isUserLogged,
  updateCurrentPaymentMethodActive,
  transactionId,
  loadPaymentMethod,
  member,
  locationData,
  index,
  directLink,
  total,
  nbPoints,
  enoughNbPoints,
  goNextStep,
  localStorageDatas,
  memberId,
  accordionIndex,
  toggleShowAccordion,
  activeCurrentIndex,
  price_level_text,
  pwpBcEnabled,
  pmid,
  bcState,
  membershipItem,
}) {
  // console.log("pmName screen", paymentName);
  // console.log("pmName screen d-link", isDirectLink);
  // console.log("isuserLogged", isUserLogged);
  // console.log("pwpData", pwpData);

  let couponExists = false;
  var totalnum = 0;
  var totalGst = 0;
  var currencyText = "";

  if (
    Object.keys(localStorageDatas.members[0]?.selected_product).length !== 0
  ) {
    if (
      localStorageDatas &&
      localStorageDatas.members.length > 0 &&
      localStorageDatas.members[0].selected_product &&
      localStorageDatas.members[0].selected_product[0].currency_text
    ) {
      currencyText =
        localStorageDatas.members[0].selected_product[0].currency_text;
    }
  }

  if (Object.keys(localStorageDatas.members[0].selected_product).length !== 0) {
    for (var i = 0; i < localStorageDatas.members.length; i++) {
      let price = "";
      let gst = "";
      if (
        localStorageDatas.members[0].selected_product &&
        localStorageDatas.members[0].selected_product[0].purchase_price
      ) {
        price = parseFloat(
          localStorageDatas.members[i].selected_product[0].purchase_price
        );
        gst = parseFloat(
          localStorageDatas.members[i].selected_product[0].tax_amt
        );
      }
      totalnum += price;
      totalGst += gst;
    }
    var totalAmt = totalnum + totalGst;
  }

  const PaymentReview = () => {
    return (
      <>
        {paymentName === "PayWithPoints" ? (
          <div className="holder-content-receipt tablet:bordered-gray tablet:bg-white py-5 tablet:px-5">
            <div className="content-receipt">
              <div className="receipt-list w-full flex flex-row">
                <p className="title font-bold">Total</p>
                <p className="value ml-auto font-bold">
                  <span className="uppercase">
                    {Number(pwpData.points)
                      .toLocaleString("en-US")
                      .replace(/,/i, " ")}
                  </span>
                  <span>
                    {" "}
                    {languages && languages.allRewardPointsYearly
                      ? languages.allRewardPointsYearly
                      : "ALL Reward points per year"}
                  </span>
                </p>
              </div>
            </div>
          </div>
        ) : (
          <div className="holder-content-receipt tablet:bordered-gray tablet:bg-white py-5 tablet:px-5">
            <div className="content-receipt">
              {couponExists == false ? (
                <div>
                  <div className="receipt-list w-full flex flex-row mb-3">
                    <p className="title font-bold">
                      {languages && languages.total ? languages.total : "Total"}
                    </p>
                    <p className="value ml-auto font-bold">
                      <span className="uppercase">{currencyText}</span>{" "}
                      {totalAmt.toFixed(0)}{" "}
                      <span>
                        {languages && languages.paymentPerYear
                          ? languages.paymentPerYear
                          : "per year"}
                      </span>
                    </p>
                  </div>
                  <div className="receipt-list w-full flex flex-row">
                    <p className="title text-gray">
                      {languages && languages.gst ? languages.gst : "GST"}
                    </p>
                    <p className="value ml-auto">
                      <span className="uppercase">{currencyText}</span>{" "}
                      {totalGst.toFixed(2)}
                    </p>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        )}
      </>
    );
  };

  return (
    <>
      {/* <BackButton goPreviousStep={goPreviousStep}/>    */}
      <div id="accordion-wrapper">
        <PaymentReview />
        {paymentName === "Stripe" && (
          <Stripe
            transactionId={transactionId || ""}
            member={member || {}}
            locationData={locationData}
            goNextStep={goNextStep}
            localStorageDatas={localStorageDatas}
          />
        )}{" "}
        {paymentName == "AsiaPay" ||
          (paymentName == "DIRECT" && (
            <AsiaPayClient
              transactionId={transactionId || ""}
              pMethod={paymentName}
              member={member || {}}
              locationData={locationData}
              goNextStep={goNextStep}
              bcState={bcState}
            />
          ))}{" "}
        {paymentName == "LimePay" && (
          <LimePay
            transactionId={transactionId || ""}
            member={member || {}}
            locationData={locationData}
            goNextStep={goNextStep}
            total={total}
            localStorageDatas={localStorageDatas}
            memberId={memberId}
            price_level_text={price_level_text}
          />
        )}
        {isDirectLink && (
          <AsiaPayDirectLink
            transactionId={transactionId || ""}
            // member={member || {}}
            locationData={locationData}
            pMethod={paymentName}
            goNextStep={goNextStep}
          />
        )}
        {paymentName == "PayWithPoints" &&
          pwpData &&
          (isUserLogged ? ( // to be updated
            <>
              <PayWithPoints
                transactionId={transactionId || ""}
                member={member || {}}
                locationData={locationData}
                languages={languages}
                pMethod={pmName}
                nbPoints={nbPoints}
                enoughNbPoints={enoughNbPoints}
                localStorageDatas={localStorageDatas}
                pmid={pmid}
                isPwpPointsEnabled={isPwpPointsEnabled}
                goNextStep={goNextStep}
                isRenewalPage={isRenewalPage}
                pwpUserData={pwpUserData}
              />
            </>
          ) : (
            ""
            // <AllLoginNotification />
            // <div className='holder-text text-center mt-5 mb-5'>
            //     <div className='holder-title mb-2'>
            //         <h5 className='text-xl tracking-tight text-gray-900 dark:text-white font-montserrat font-bold'>{languages && languages.pwpLoginMessageError ? languages.pwpLoginMessageError : 'You are not logged in'}</h5>
            //     </div>
            //     <div>
            //         <p className='pt-1 font-montserrat'>{languages && languages.pwpLoginMessage ? languages.pwpLoginMessage : 'Please log in with your ALL credentials.'}</p>
            //     </div>
            //     <div className='mt-4'>
            //         <a href="https://login.accor.com/as/authorization.oauth2?client_id=com.accorplus&response_type=code&persistent=yes&scope=openid+PROFILE.READ+PROFILE.WRITE+PROFILE.WALLET&redirect_uri=https%3A%2F%2Fwww.accorplus.com%2Fcallback" target="_blank" className='btn btn-blue inline-block px-6 py-2.5 text-white font-montserrat font-medium leading-tight uppercase rounded shadow-md ease-in-out'>{languages && languages.pwpLoginButton ? languages.pwpLoginButton : 'LOG IN'}</a>
            //     </div>
            // </div>
          ))}
      </div>
    </>
  );
}
